import React, { memo } from 'react';
import { ArrowDownIcon, ArrowUpIcon, Box, HStack, Text } from 'native-base';
const ColoredDifferenceAmount = _ref => {
  let {
    difference,
    id
  } = _ref;
  if (!difference) return /*#__PURE__*/React.createElement(Box, {
    testID: "difference-amount-zero"
  });
  return /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "flex-end",
    alignItems: "center",
    key: id,
    mb: {
      base: '1'
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, difference > 0 ? /*#__PURE__*/React.createElement(ArrowUpIcon, {
    size: "xs",
    color: "red.500"
  }) : /*#__PURE__*/React.createElement(ArrowDownIcon, {
    size: "xs",
    color: "green.400"
  }), /*#__PURE__*/React.createElement(Text, {
    color: difference > 0 ? 'red.500' : 'green.400',
    fontSize: {
      base: 'xs',
      md: 'sm',
      lg: 'sm'
    },
    accessibilityLabel: `$${Number(Math.abs(difference)).toFixed(2)}`
  }, "$", Number(Math.abs(difference)).toFixed(2))));
};
export default /*#__PURE__*/memo(ColoredDifferenceAmount);
//# sourceMappingURL=index.js.map